import './CreateDialog.scss';

import { yupResolver } from '@hookform/resolvers/yup';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { useEffect, useMemo } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldWithErrors from '../../../Forms/ReactHookForm/FieldWithErrors';
import {
  CreateHoliday,
  getInitialValues,
  getValidationSchema,
  toApiData,
} from './CreateDialog.functions';

type Props = {
  isEditDialog: boolean;
  holidayData: any;
  handleCreation: (v: CreateHoliday) => void;
  handleEditing: (v: CreateHoliday) => void;
};

function FormContainer({
  isEditDialog,
  holidayData,
  handleCreation,
  handleEditing,
}: Props) {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => getValidationSchema(t), [t]);

  const defaultValues = useMemo(
    () => getInitialValues(isEditDialog, holidayData),
    [holidayData, isEditDialog]
  );

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  });

  const { handleSubmit, reset, watch } = methods;
  const values = watch();
  console.log('values ', values);
  // useEffect(() => {
  //   reset(defaultValues);
  // }, [defaultValues, reset]);

  function handleFormSubmission(values: CreateHoliday) {
    const params = toApiData(values);
    console.log('params ', params);
    if (isEditDialog) {
      handleEditing(params);
    } else {
      handleCreation(params);
    }
  }

  return (
    <FormProvider {...methods}>
      <form
        id="create-edit-holiday"
        onSubmit={handleSubmit(handleFormSubmission)}
      >
        <div className="general-info-tab p-fluid">
          <span className="section-title">{t('General information')}</span>
          <FieldWithErrors name="description" label={t('Description')}>
            <Controller
              name="description"
              render={({ field }) => (
                <InputText
                  name="description"
                  id="description"
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </FieldWithErrors>
          <FieldWithErrors name="date" label={t('Date')}>
            <Controller
              name="date"
              render={({ field }) => (
                <Calendar
                  id="date"
                  value={field.value || null}
                  onChange={(e) => field.onChange(e.value)}
                  dateFormat="yy-mm-dd"
                  showIcon
                  minDate={new Date()}
                  showTime={false}
                  placeholder={t('Select date')}
                />
              )}
            />
          </FieldWithErrors>
        </div>
      </form>
    </FormProvider>
  );
}

export default FormContainer;
